import { useNavigation } from 'react-day-picker';

// Components
import Icon from '@/components/base/Icon';

export function Navigation() {
    // Can be a empty string to avoid some problems when the use remove all the date
    const { previousMonth, nextMonth, goToMonth } = useNavigation();

    const handlePreviousClick: React.MouseEventHandler = () => {
        goToMonth(previousMonth);
    };

    const handleNextClick: React.MouseEventHandler = () => {
        goToMonth(nextMonth);
    };

    return (
        <div className="flex items-center gap-3 text-xs text-icoGray-400 dark:text-icoDarkMode-wolf">
            <button
                onClick={handlePreviousClick}
                disabled={!previousMonth}
                data-testid="datepicker-previous-month-button"
                className="flex items-center focus:ring-0 focus:ring-offset-0 disabled:opacity-40">
                <Icon icon="chevron-left" />
            </button>
            <button
                onClick={handleNextClick}
                disabled={!nextMonth}
                data-testid="datepicker-next-month-button"
                className="flex items-center focus:ring-0 focus:ring-offset-0 disabled:opacity-40">
                <Icon icon="chevron-right" />
            </button>
        </div>
    );
}
